import styled from 'styled-components/macro';
import Button from '../Button';

const ControlButton = styled(Button)`
  path {
    fill: #fff;
    opacity: 0.4;
    transition: opacity 0.15s ease-out;
  }

  &:hover path {
    opacity: 1;
  }
`;

export default ControlButton;
